import * as z$1 from "zod/v4";
//#region src/account-session.ts
const ACCOUNT_SESSION_PATH = "/v1/account/session";
const accountSessionSchema = z$1.strictObject({
	user: z$1.strictObject({
		id: z$1.string().min(1),
		email: z$1.string(),
		name: z$1.string(),
		image: z$1.string().nullable(),
		emailVerified: z$1.boolean(),
		createdAt: z$1.iso.datetime()
	}),
	session: z$1.strictObject({ id: z$1.string().min(1) })
});
//#endregion
export { ACCOUNT_SESSION_PATH, accountSessionSchema };

//# sourceMappingURL=account-session.js.map